import { ABTest } from '../../declarations/ab-test';

export type ABTestStatus = 'scheduled' | 'running' | 'finished';

/**
 * Statut d'un test A/B déjà déclaré, dérivé de ses dates (pas de champ statut côté backend — même logique côté
 * serveur, dupliquée ici faute d'endpoint dédié). Distinct du mode d'édition de l'écran A/B,
 * qui porte en plus un état "aucun test", sans sens pour un test déjà déclaré.
 */
export function getABTestStatus(test: ABTest, now: number = Date.now()): ABTestStatus {
  if (now < test.startDate) return 'scheduled';
  if (now < test.endDate) return 'running';
  return 'finished';
}

/**
 * Gating fin des actions de gestion d'un test A/B (création/édition/arrêt) : il faut à la fois le module activé
 * sur l'engine et la permission d'éditer le contenu de la source. Centralise une logique auparavant recalculée
 * séparément dans SourceSetupComponent et AbTestComponent — confort UX uniquement, l'autorité réelle reste serveur.
 */
export function canManageABTests(hasModule: boolean, permissions: { editContent?: boolean } | null | undefined): boolean {
  return hasModule && !!permissions?.editContent;
}
